module.exports = __webpack_public_path__ + "static/img/product-poster-3.b2eaf00d.png";